import { ChangePasswordData, ActionType } from "models/changePassword";
import { IResponse } from "models";

export const changePasswordAction = (payload: ChangePasswordData) => {
  return {
    type: ActionType.CHANGE_PASSWORD,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.CHANGE_PASSWORD_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.CHANGE_PASSWORD_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_CHANGE_PASSWORD,
  };
};
